import { cn } from "@/shared/lib/utils";

interface BrandMarkProps {
  /** Visual tone. `onDark` para el panel brand, `onLight` para el form panel y futuros usos. */
  tone?: "onDark" | "onLight";
  /** Tamaño del lockup. `md` default; `lg` para hero. */
  size?: "sm" | "md" | "lg";
  /** Clases extra para spacing externo. */
  className?: string;
}

/**
 * Lockup tipográfico de la marca. Serif variable (Fraunces) para "Arya",
 * sans micro para "Backoffice". Un solo lugar donde se decide cómo se
 * escribe el nombre — si cambia, cambia en todo lado.
 */
export function BrandMark({ tone = "onLight", size = "md", className }: BrandMarkProps) {
  const sizes = {
    sm: { arya: "text-lg", dot: "mx-1.5 text-base", tag: "text-[10px]" },
    md: { arya: "text-xl", dot: "mx-2 text-lg", tag: "text-[11px]" },
    lg: { arya: "text-2xl", dot: "mx-2 text-xl", tag: "text-xs" },
  }[size];

  const colors =
    tone === "onDark"
      ? { arya: "text-arya-cream", dot: "text-arya-cream/40", tag: "text-arya-cream/55" }
      : { arya: "text-foreground", dot: "text-muted-foreground/50", tag: "text-muted-foreground" };

  return (
    <div
      className={cn("inline-flex items-baseline leading-none", className)}
      aria-label="Arya Backoffice"
    >
      <span
        className={cn("font-display font-medium tracking-display-tight", sizes.arya, colors.arya)}
      >
        Arya
      </span>
      <span className={cn("font-display", sizes.dot, colors.dot)}>·</span>
      <span
        className={cn("font-sans font-medium uppercase tracking-[0.22em]", sizes.tag, colors.tag)}
      >
        Backoffice
      </span>
    </div>
  );
}
